export default __webpack_public_path__ + "static/suitprofile2-4afc8264b2bdbe9659af06b6e3e56ef9.png";